import "./App.css";
import Portfolio from "./Components/landing.js";

function App() {
  return (
    <div className="App">
      <Portfolio></Portfolio>
    </div>
  );
}

export default App;
